// ============================================================
//  CONFIG CLIENT — seul fichier à modifier par déploiement
// ============================================================

const config = {

  // --- IDENTITÉ ---
  clientName:  "Innov’ Connect",     // ex: "Bazin"
  clientShort: "INN",    // ex: "BZN" (sidebar repliée)

  // --- COULEURS ---
  primaryColor: "#2563eb",  // ex: "#00d2ff"
  accentColor:  "#3b82f6",   // ex: "#007bff"

  // --- API ---
  apiBase: "https://innov.ams-crm.fr/api",            // ex: "https://bazin.ams-crm.fr/api"

  // --- AUTH ---
  // Clés utilisées dans localStorage
  tokenKey: "innov_token",          // ex: "authToken"
  userKey:  "innov_user",           // ex: "adminUser"
  // Champ login renvoyé par l'API dans data.user
  loginField: "username",      // ex: "username" ou "login"

  // --- ROUTE PAR DÉFAUT APRÈS LOGIN ---
  defaultRoute: "/planning",  // ex: "/planning"

  // --- APPS ---
  // Ajoute / supprime selon le client
  apps: [
    { key: "planning", label: "Planning",    icon: "📅", url: "https://planning.innov.ams-crm.fr" },
    { key: "appels",   label: "Appels",  icon: "📞", url: "https://appel.innov.ams-crm.fr"   },
    { key: "kanban",   label: "Kanban",      icon: "🧾", url: "https://kanban.innov.ams-crm.fr"   },
    { key: "cdr",      label: "Parc télécom", icon: "📱", url: "https://extranet.innov-connect.fr", adminOnly: true },
  ]

};

export default config;
